import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { B2CUserInjection } from "features/b2cUserManagement/di/B2CUserInjection";
import { injectable } from "tsyringe";
import { B2CDetailUserEntity } from "../entities/B2CDetailUserEntity";
import { B2CUserActionRequestEntity } from "../entities/B2CUserActionRequestEntity";
import { B2CUserRequestEntity } from "../entities/B2CUserRequestEntity";
import { B2CUserResponseEntity } from "../entities/B2CUserResponseEntity";
import { IB2CUserRepository } from "../repositories/IB2CUserRepository";

@injectable()
export class B2CUserManagementUseCase {
  private b2cUserRepo: IB2CUserRepository;

  constructor() {
    this.b2cUserRepo = B2CUserInjection.getRepo();
  }

  async getList(
    params: B2CUserRequestEntity,
    path: string,
  ): Promise<ListBaseApiResponseModel<B2CUserResponseEntity>> {
    return await this.b2cUserRepo.getList(params, path);
  }

  async getDetail(
    params: B2CUserRequestEntity,
    path: string,
  ): Promise<
    BaseApiResponseModel<B2CUserResponseEntity & B2CDetailUserEntity>
  > {
    return await this.b2cUserRepo.getDetail(params, path);
  }

  async createUser(
    body: B2CUserActionRequestEntity,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseEntity>> {
    return await this.b2cUserRepo.createUser(body, path);
  }

  async updateUser(
    body: B2CUserActionRequestEntity,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseEntity>> {
    return await this.b2cUserRepo.updateUser(body, path);
  }

  async deleteUser(
    params: B2CUserActionRequestEntity,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseEntity>> {
    return await this.b2cUserRepo.deleteUser(params, path);
  }
}
